<template>
  <div class="settle-record-container">
    <el-tabs v-model="activeTab">
      <el-tab-pane :label="$t('settle.tab.record')" name="record">
    <!-- 汇总卡片 -->
    <el-row :gutter="20" class="summary-wrapper" style="margin-bottom: 16px">
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="summary-item">
            <div class="summary-label">{{ $t('settle.summary.available') }}</div>
            <div class="summary-value" style="color: #67c23a">
              <span class="summary-symbol">¥</span> {{ Number(summary.availableAmount || 0).toFixed(2) }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="summary-item">
            <div class="summary-label">{{ $t('settle.summary.frozen') }}</div>
            <div class="summary-value" style="color: #e6a23c">
              <span class="summary-symbol">¥</span> {{ Number(summary.frozenAmount || 0).toFixed(2) }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="summary-item">
            <div class="summary-label">{{ $t('settle.summary.audit') }}</div>
            <div class="summary-value" style="color: #909399">
              <span class="summary-symbol">¥</span> {{ Number(summary.auditAmount || 0).toFixed(2) }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="summary-item">
            <div class="summary-label">{{ $t('settle.summary.owe') }}</div>
            <div class="summary-value" style="color: #409eff">
              <span class="summary-symbol">¥</span> {{ Number(summary.oweAmount || 0).toFixed(2) }}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 结算记录列表 -->
    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between" style="align-items: center">
        <span>{{ $t('settle.list.title') }}</span>
        <el-button type="primary" :disabled="Number(summary.availableAmount || 0) < 10" @click="handleApply">
          <i class="el-icon-money"></i>
          {{ $t('settle.applyButton') }}
        </el-button>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-wrapper">
        <div class="filter-left">
        <el-form :inline="true" size="small">
          <el-form-item :label="$t('settle.filter.timeLabel')">
            <el-date-picker
              v-model="filter.timeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('settle.filter.startPlaceholder')"
              :end-placeholder="$t('settle.filter.endPlaceholder')"
              value-format="yyyy-MM-dd"
              style="width: 250px"
            />
          </el-form-item>
          <el-form-item :label="$t('settle.list.auditStatus')">
            <el-select v-model="filter.auditStatus" :placeholder="$t('settle.filter.all')" clearable style="width: 120px">
              <el-option v-for="(label, key) in $t('settle.auditStatus')" :key="key" :label="label" :value="key" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('settle.list.arriveStatus')">
            <el-select v-model="filter.arriveStatus" :placeholder="$t('settle.filter.all')" clearable style="width: 120px">
              <el-option v-for="(label, key) in $t('settle.arriveStatus')" :key="key" :label="label" :value="key" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('settle.list.settleType')">
            <el-select v-model="filter.settleType" :placeholder="$t('settle.filter.all')" clearable style="width: 130px">
              <el-option :label="$t('settle.settleTypeMap.internal')" value="0" />
              <el-option :label="$t('settle.settleTypeMap.bank')" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('settle.list.settleNo')">
            <el-input
              v-model="filter.settleNo"
              :placeholder="$t('settle.filter.settleNoPlaceholder')"
              clearable
              style="width: 180px"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
        </el-form>
        </div>
        <div class="filter-right">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('settle.filter.search') }}</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">{{ $t('settle.filter.reset') }}</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="settleNo" :label="$t('settle.list.settleNo')" align="center" min-width="150" />
        <el-table-column prop="amount" :label="$t('settle.list.amount')" align="center" width="120">
          <template slot-scope="scope">
            {{ Number(scope.row.amount || 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('settle.list.settleType')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.settleType === '0' ? 'info' : 'warning'" size="small">
              {{ scope.row.settleType === '0' ? $t('settle.settleTypeMap.internal') : $t('settle.settleTypeMap.bank') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" :label="$t('settle.list.ownerName')" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.ownerName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bankName" :label="$t('settle.list.bankName')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.bankName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bankCard" :label="$t('settle.list.bankCard')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.bankCard || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('settle.list.auditStatus')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="$t('settle.auditTag')[scope.row.auditStatus] || 'info'">
              {{ $t('settle.auditStatus')[scope.row.auditStatus] || scope.row.auditStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('settle.list.settleAmount')" align="center" width="120">
          <template slot-scope="scope">
            <span style="color: #409eff">¥ {{ Number(scope.row.settleAmount || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('settle.list.arriveStatus')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="$t('settle.arriveTag')[scope.row.arriveStatus] || 'info'">
              {{ $t('settle.arriveStatus')[scope.row.arriveStatus] || scope.row.arriveStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyRemark" :label="$t('settle.list.applyRemark')" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.applyRemark || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="platformRemark" :label="$t('settle.list.platformRemark')" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.platformRemark || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" :label="$t('settle.list.applyTime')" align="center" width="160" />
        <el-table-column :label="$t('settle.list.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">{{ $t('settle.list.detail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <div class="tip-left">
          <el-alert :title="$t('settle.tip')" type="info" :closable="false" />
        </div>
        <div class="pager-right">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </el-card>

      </el-tab-pane>
      <el-tab-pane :label="$t('settle.tab.account')" name="account">
        <settle-account-form v-if="activeTab === 'account'" />
      </el-tab-pane>
    </el-tabs>

    <!-- 提现申请弹窗 -->
    <el-dialog custom-class="apply-dialog" :title="$t('settle.applyDialog.title')" :visible.sync="applyDialogVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="applyForm" :model="applyForm" :rules="applyRules" label-width="110px">
        <el-form-item :label="$t('settle.applyDialog.available')">
          <span style="color: #67c23a; font-size: 18px; font-weight: bold">
            ¥ {{ Number(summary.availableAmount || 0).toFixed(2) }}
          </span>

        </el-form-item>
        <el-form-item :label="$t('settle.applyDialog.type')" prop="settleType">
          <el-radio-group v-model="applyForm.settleType">
            <el-radio :label="'0'">{{ $t('settle.applyDialog.typeInternal') }}</el-radio>
            <el-radio :label="'1'">{{ $t('settle.applyDialog.typeBank') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="applyForm.settleType === '1'" :label="$t('settle.applyDialog.bank')" prop="bankId">
          <el-select v-model="applyForm.bankId" :placeholder="$t('settle.applyDialog.bankPlaceholder')" style="width: 100%" @change="handleBankChange">
            <el-option v-for="item in bankOptions" :key="item.bankId" :label="item.bankName + '（手续费 ¥' + Number(item.bankFee || 0).toFixed(2) + '/笔）'" :value="item.bankId">
              <span>{{ item.bankName }}</span>
              <span style="float: right; color: #e6a23c; font-size: 12px">手续费 ¥{{ Number(item.bankFee || 0).toFixed(2) }}/笔</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('settle.applyDialog.amount')" prop="amount">
          <el-input-number
            v-model="applyForm.amount"
            :min="10"
            :max="Number(summary.availableAmount || 0)"
            :precision="2"
            :step="1"
            style="width: 100%"
          />
          <div style="font-size: 12px; color: #e6a23c; line-height: 1.5; margin-top: 4px">
            {{ $t('settle.applyDialog.amountMinLimit') }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('settle.applyDialog.settleAmount')">
          <span style="color: #409eff; font-size: 18px; font-weight: bold">¥ {{ settleAmountPreview.toFixed(2) }}</span>
          <span style="margin-left: 8px; font-size: 12px; color: #909399">
            （{{ $t('settle.applyDialog.platformFeePrefix') }}<b style="color: #e6a23c; font-size: 13px; font-weight: bold">{{ Number(summary.shareRate || 0).toFixed(2) }}%</b>{{ $t('settle.applyDialog.platformFeeSuffix') }}）
          </span>
        </el-form-item>
        <el-form-item :label="$t('settle.applyDialog.remark')">
          <el-input v-model="applyForm.applyRemark" type="textarea" :rows="1" :placeholder="$t('settle.applyDialog.remarkPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('settle.applyDialog.invoice')">
          <template v-if="accountInfo">
            <div class="invoice-tip">{{ $t('settle.applyDialog.invoiceAutoTip') }}</div>
            <div class="invoice-box">
              <div class="invoice-row">
                <span class="invoice-label">{{ $t('settleAccount.storeName') }}：</span>{{ accountInfo.storeName || '-' }}
              </div>
              <div class="invoice-row">
                <span class="invoice-label">{{ $t('settleAccount.ownerName') }}：</span>{{ accountInfo.ownerName || '-' }}
              </div>
              <div class="invoice-row">
                <span class="invoice-label">{{ $t('settleAccount.bankName') }}：</span>{{ accountInfo.bankName || '-' }}
              </div>
              <div class="invoice-row">
                <span class="invoice-label">{{ $t('settleAccount.bankCard') }}：</span>{{ accountInfo.bankCard || '-' }}
              </div>
              <div class="invoice-row">
                <span class="invoice-label">{{ $t('settleAccount.bankAddress') }}：</span>{{ accountInfo.bankAddress || '-' }}
              </div>
            </div>
          </template>
          <template v-else>
            <el-alert
              :title="$t('settle.applyDialog.invoiceEmpty')"
              type="warning"
              :closable="false"
              style="margin-bottom: 8px"
            />
            <el-button type="text" @click="goSetting">{{ $t('settle.applyDialog.goSetting') }} →</el-button>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="applyDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" :loading="applying" @click="handleSubmitApply">{{ $t('settle.applyDialog.submit') }}</el-button>
      </div>
    </el-dialog>

    <!-- 结算单详情 -->
    <el-dialog custom-class="settle-detail-dialog" :title="$t('settle.detailDialog.title')" :visible.sync="detailVisible" width="560px" :close-on-click-modal="false">
      <div class="detail-box">
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.settleNo') }}</span><span>{{ detailRow.settleNo || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.amount') }}</span><span>¥ {{ Number(detailRow.amount || 0).toFixed(2) }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.settleType') }}</span>
          <span>{{ detailRow.settleType === '0' ? $t('settle.settleTypeMap.internal') : $t('settle.settleTypeMap.bank') }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.ownerName') }}</span><span>{{ detailRow.ownerName || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.bankName') }}</span><span>{{ detailRow.bankName || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.bankCard') }}</span><span>{{ detailRow.bankCard || '-' }}</span></div>
        <div v-if="detailRow.settleType === '1'" class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.bankFee') }}</span><span>¥ {{ Number(detailRow.bankFee || 0).toFixed(2) }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.platformFee') }}</span><span>¥ {{ Number(detailRow.platformFee || 0).toFixed(2) }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.settleAmount') }}</span><span>¥ {{ Number(detailRow.settleAmount || 0).toFixed(2) }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.auditStatus') }}</span>
          <span>{{ $t('settle.auditStatus')[detailRow.auditStatus] || detailRow.auditStatus }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.arriveStatus') }}</span>
          <span>{{ $t('settle.arriveStatus')[detailRow.arriveStatus] || detailRow.arriveStatus }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.applyRemark') }}</span><span>{{ detailRow.applyRemark || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.platformRemark') }}</span><span>{{ detailRow.platformRemark || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.applyTime') }}</span><span>{{ detailRow.applyTime || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.auditTime') }}</span><span>{{ detailRow.auditTime || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">{{ $t('settle.detailDialog.arriveTime') }}</span><span>{{ detailRow.arriveTime || '-' }}</span></div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('settle.detailDialog.voucher') }}</span>
          <span v-if="detailRow.voucherUrl">
            <el-image
              style="width: 90px; height: 90px; border-radius: 4px; margin: 4px 0"
              :src="detailRow.voucherUrl"
              fit="cover"
              :preview-src-list="[detailRow.voucherUrl]"
            />
          </span>
          <span v-else>{{ $t('settle.detailDialog.noVoucher') }}</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">{{ $t('settle.detailDialog.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { querySettleSummary, applySettle, listSettleOrders, querySettleAccount } from '@/api/fee/settleApi'
import SettleAccountForm from '@/components/fee/SettleAccountForm'
import { listBankInfoForStore } from '@/api/system/bankInfoApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'settleRecordList',
  components: {
    SettleAccountForm
  },
  data() {
    return {
      loading: false,
      applying: false,
      summary: {},
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      communityId: '',
      activeTab: 'record',
      filter: {
        settleNo: '',
        auditStatus: '',
        arriveStatus: '',
        settleType: '',
        timeRange: []
      },
      applyDialogVisible: false,
      detailVisible: false,
      detailRow: {},
      bankOptions: [],
      accountInfo: null,
      applyForm: {
        settleType: '0',
        bankId: '',
        amount: 0,
        applyRemark: ''
      },
      applyRules: {
        settleType: [{ required: true, message: this.$t('settle.applyDialog.type'), trigger: 'change' }],
        bankId: [{ required: true, message: this.$t('settle.applyDialog.bankRequired'), trigger: 'change' }],
        amount: [{ required: true, message: this.$t('settle.applyDialog.amountRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    selectedBank() {
      return this.bankOptions.find(item => item.bankId === this.applyForm.bankId) || null
    },
    platformFeePreview() {
      const amount = Number(this.applyForm.amount || 0)
      const rate = Number(this.summary.shareRate || 0)
      return amount * rate / 100
    },
    settleAmountPreview() {
      const amount = Number(this.applyForm.amount || 0)
      let fee = this.platformFeePreview
      if (this.applyForm.settleType === '1' && this.selectedBank) {
        fee += Number(this.selectedBank.bankFee || 0)
      }
      return Math.max(0, amount - fee)
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._loadSummary()
    this._loadData()
    this._loadBanks()
    this._loadAccount()
  },
  methods: {
    _loadSummary() {
      querySettleSummary({
        communityId: this.communityId
      }).then(res => {
        if (res.code === 0) {
          this.summary = res.data || {}
        }
      })
    },
    _loadData() {
      this.loading = true
      const params = {
        page: this.currentPage,
        row: this.pageSize,
        communityId: this.communityId
      }
      if (this.filter.settleNo) params.settleNo = this.filter.settleNo
      if (this.filter.auditStatus !== '') params.auditStatus = this.filter.auditStatus
      if (this.filter.arriveStatus !== '') params.arriveStatus = this.filter.arriveStatus
      if (this.filter.settleType !== '') params.settleType = this.filter.settleType
      if (this.filter.timeRange && this.filter.timeRange.length === 2) {
        params.startTime = this.filter.timeRange[0] + ' 00:00:00'
        params.endTime = this.filter.timeRange[1] + ' 23:59:59'
      }
      listSettleOrders(params).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.tableData = res.data || []
          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    _loadBanks() {
      listBankInfoForStore({ page: 1, row: 100, bankName: '' }).then(res => {
        if (res.code === 0) {
          this.bankOptions = res.data || []
        }
      })
    },
    _loadAccount() {
      querySettleAccount({ communityId: this.communityId }).then(res => {
        if (res.code === 0) {
          this.accountInfo = res.data || null
        }
      })
    },
    handleBankChange() {
      // 选中银行后若金额为空，不强制操作
    },
    handleDetail(row) {
      this.detailRow = row
      this.detailVisible = true
    },
    handleApply() {
      this.applyForm = {
        settleType: '0',
        bankId: '',
        amount: 0,
        applyRemark: ''
      }
      this.applyDialogVisible = true
    },
    goSetting() {
      this.applyDialogVisible = false
      this.activeTab = 'account'
    },
    handleSubmitApply() {
      if (!this.accountInfo) {
        this.$message.warning(this.$t('settle.applyDialog.invoiceEmpty'))
        return
      }
      if (this.applyForm.settleType === '1' && !this.applyForm.bankId) {
        this.$message.warning(this.$t('settle.applyDialog.bankRequired'))
        return
      }
      if (!this.applyForm.amount || Number(this.applyForm.amount) <= 0) {
        this.$message.warning(this.$t('settle.applyDialog.amountRequired'))
        return
      }
      if (Number(this.applyForm.amount) < 10) {
        this.$message.warning(this.$t('settle.applyDialog.amountMinLimit'))
        return
      }
      if (Number(this.applyForm.amount) > Number(Number(this.summary.availableAmount || 0).toFixed(2))) {
        this.$message.warning(this.$t('settle.applyDialog.amountLimit'))
        return
      }
      this.applying = true
      const data = {
        communityId: this.communityId,
        amount: this.applyForm.amount,
        settleType: this.applyForm.settleType,
        applyRemark: this.applyForm.applyRemark || ''
      }
      if (this.applyForm.settleType === '1') {
        data.bankId = this.applyForm.bankId
      }
      applySettle(data).then(res => {
        this.applying = false
        if (res.code === 0) {
          this.$message.success(this.$t('settle.applyDialog.success'))
          this.applyDialogVisible = false
          this._loadSummary()
          this.currentPage = 1
          this._loadData()
        } else {
          this.$message.error(res.msg || '申请失败')
        }
      }).catch(() => {
        this.applying = false
      })
    },
    handleSearch() {
      this.currentPage = 1
      this._loadData()
    },
    handleReset() {
      this.filter = {
        settleNo: '',
        auditStatus: '',
        arriveStatus: '',
        settleType: '',
        timeRange: []
      }
      this.currentPage = 1
      this._loadData()
    },
    handlePageChange() {
      this._loadData()
    }
  }
}
</script>

<style scoped>
.summary-card {
  border-radius: 8px;
}
.summary-item {
  text-align: center;
  padding: 8px 0;
}
.summary-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}
.summary-value {
  font-size: 28px;
  font-weight: bold;
}
.summary-symbol {
  font-size: 18px;
  margin-right: 2px;
}
/* 筛选栏：选项靠左、按钮靠右 */
.filter-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.filter-left {
  flex: 1;
  min-width: 0;
}
.filter-left /deep/ .el-form-item {
  margin-bottom: 0;
}
.filter-right {
  flex-shrink: 0;
  margin-left: 12px;
}
/* 分页行：说明靠左、分页靠右 */
.pagination-wrapper {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pagination-wrapper .tip-left {
  flex: 1;
  margin-right: 12px;
  min-width: 0;
}
.pagination-wrapper .tip-left /deep/ .el-alert {
  padding: 6px 12px;
  line-height: 1.5;
}
.pagination-wrapper .pager-right {
  flex-shrink: 0;
}
/* 弹窗内容靠左：App.vue 全局 #app{text-align:center} 会继承进弹窗，导致金额/单选/发票文本居中 */
::v-deep .apply-dialog {
  text-align: left;
}
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}
.invoice-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-bottom: 8px;
}
.invoice-box {
  width: 100%;
  padding: 8px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
  overflow: hidden;
}
.invoice-row {
  font-size: 13px;
  line-height: 1.9;
  color: #606266;
  word-break: break-all;
}
.invoice-label {
  color: #909399;
}
/* 详情弹窗内容靠左（全局 #app{text-align:center} 会继承） */
::v-deep .settle-detail-dialog {
  text-align: left;
}
.detail-box {
  max-height: 60vh;
  overflow-y: auto;
}
.detail-row {
  display: flex;
  font-size: 13px;
  line-height: 2;
  color: #606266;
  word-break: break-all;
  border-bottom: 1px solid #f0f0f0;
}
.detail-label {
  width: 110px;
  flex-shrink: 0;
  color: #909399;
}
</style>
